import { firestore } from "@/firebase";
export class Reader {
  _firestore = firestore;
  static STATUS_READY = "STATUS_READY";
  static STATUS_RUNNING = "STATUS_RUNNING";
  static STATUS_IDLE = "STATUS_IDLE";
  status = Reader.STATUS_IDLE;

  _setStatusRunning() {
    this.status = Reader.STATUS_RUNNING;
  }

  _setStatusReady() {
    this.status = Reader.STATUS_READY;
  }

  _makeReadyPromise() {
    let done;
    let p = new Promise(resolve => {
      done = resolve.bind(this);
    });
    return { p, done };
  }
  setFirestore(firestore) {
    this._firestore = firestore;
  }

  get ready() {
    return this.status == Reader.STATUS_READY;
  }
}
